import React from 'react';
import {
  ContainerCarregando,
  Spinner,
  MensagemCarregando,
} from '../../style/ModalDesignacao.styles';

const LoadingState = () => (
  <ContainerCarregando>
    <Spinner />
    <MensagemCarregando>Carregando...</MensagemCarregando>
  </ContainerCarregando>
);

export default LoadingState;
